import * as Constants from '../constants';

const initialState = {
  action: {},
  selectedCity: {},
  servicablePincodes: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.FETCH_ADDRESSES_START:
    case Constants.LOAD_LAB_SERVICEABILITY_START:
    case Constants.DELETE_ADDRESS_START:
    case Constants.EDIT_ADDRESS_START:
      return Object.assign({}, state, { data: state.data, loading: true, action });

    case Constants.FETCH_ADDRESSES_SUCCESS:
      return Object.assign({}, state, action.data, { loading: false, action });

    case Constants.DELETE_ADDRESS_SUCCESS:
      const deleteTempState = state.data.filter(({ id }) => id !== action.data.data.id);
      return Object.assign({}, state, { data: deleteTempState }, { loading: false, action });

    case Constants.LOAD_LAB_SERVICEABILITY_SUCCESS:
      return {
        ...state,
        servicablePincodes: action.data.data.serviceability,
        loading: false,
        action
      };

    case Constants.EDIT_ADDRESS_SUCCESS:
      const editTempState = state.data.map(item => {
        if (item.id === action.data.data[0].id) {
          item = action.data.data[0];
        }
        return item;
      });

      return Object.assign({}, state, { data: editTempState }, { loading: false, action });
    case Constants.ADD_ADDRESS_START:
      return Object.assign({}, state, { data: state.data, loading: true, action });

    case Constants.ADD_ADDRESS_SUCCESS:
      return Object.assign({}, state, { data: state.data.concat(action.data.data) }, { loading: false, action });


    case Constants.FETCH_CITY_DETAILS_START:
      return { ...state, loading: true };
    case Constants.FETCH_CITY_DETAILS_SUCCESS:
      let cityDetails = {};
      if (action.data.status) {
        cityDetails = action.data.data;
      }
      return { ...state, selectedCity: cityDetails, loading: false };
    case Constants.FETCH_CITY_DETAILS_FAILURE:
      return { ...state, loading: false };

    case Constants.DELETE_ADDRESS_FAILURE:
    case Constants.FETCH_ADDRESSES_FAILURE:
    case Constants.LOAD_LAB_SERVICEABILITY_FAIL:
    case Constants.EDIT_ADDRESS_FAILURE:
    case Constants.ADD_ADDRESS_FAILURE:
      return Object.assign({}, state, { data: state.data, loading: false, action });

    default:
      return { ...state };
  }
}
